import { Check, CalendarCheck, Car, Sparkles } from "lucide-react";

const STEPS = [["bekreftet", "Bekreftet", CalendarCheck], ["pa_vei", "På vei", Car], ["fullfort", "Ferdig", Sparkles]];

export const Tracker = ({ status }) => {
  if (["avbestilt", "utlopt", "venter_betaling", "venter_godkjenning"].includes(status)) return null;
  const idx = STEPS.findIndex(([k]) => k === status);
  return (
    <div className="flex items-center gap-1 py-2" data-testid="order-tracker">
      {STEPS.map(([k, label, Icon], i) => {
        const done = i <= idx;
        const now = i === idx && k !== "fullfort";
        return (
          <div key={k} className="flex flex-1 items-center gap-1 last:flex-none">
            <div className="flex flex-col items-center gap-1">
              <span className={`flex h-8 w-8 items-center justify-center rounded-full transition-colors ${done ? "bg-[#2F5D50] text-white" : "bg-stone-200 text-stone-400"} ${now ? "animate-pulse" : ""}`}>
                {done && i < idx ? <Check className="h-4 w-4" /> : <Icon className="h-4 w-4" />}
              </span>
              <span data-testid={`tracker-${k}`} className={`text-[11px] font-semibold ${done ? "text-[#2F5D50]" : "text-stone-400"}`}>{label}</span>
            </div>
            {i < STEPS.length - 1 && <div className={`mb-5 h-1 flex-1 rounded ${i < idx ? "bg-[#2F5D50]" : "bg-stone-200"}`} />}
          </div>
        );
      })}
    </div>
  );
};
